import React from 'react';
import TableSelectBox from "../Componnets/TableSelectBox";
import {Scrollbars} from "react-custom-scrollbars";
import HelpInfoBox from "../Componnets/HelpInfoBox/HelpInfoBox";
import dataConnectorContext from "./context/dataConnectorContext";
export default class DataPreview extends React.Component {
  static contextType = dataConnectorContext
  constructor(props) {
    super(props);
    this.state = {
      saved: false,
      suggestions: [],
      defaultSuggestion:[],
      table: [],
      name: [],
      defaultName: [],
      allowDelete: [],
      showAddColumns:true,
      exCol:[],
      extraColumns:[],
      dataPreview:''
    };
  }

  componentDidMount() {
    // this.setTableData()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.context.state.dataPreview !== this.state.dataPreview){
      // console.log('pooriya',this.context.state.template,this.context.state.dataPreview.table && JSON.parse(this.context.state.dataPreview.table),this.state.dataPreview.table && JSON.parse(this.state.dataPreview.table))
      this.setState({dataPreview:this.context.state.dataPreview},()=>{
        this.setTableData()
      })
    }
  }

  setTableData = () => {
    let {suggestions, table} = this.context.state.dataPreview , allowDelete = [] ,exCol = []
    // this.setState({name:this.context.state.orderName})
    table = JSON.parse(table)
    console.log('ZZZZ', this.context.state.dataPreview, table , suggestions)
    let defaultName = []
    Object.keys(suggestions).forEach((key) => {
      defaultName.push(suggestions[key].column)
    })
    Object.keys(this.context.state.addColumns).forEach((column) => {
      console.log('this.props.addColumns ssss',column,suggestions)
      suggestions[column] = this.context.state.addColumns[column]
      defaultName = defaultName.concat(column)
      exCol = exCol.concat(column)
      // allowDelete = allowDelete.concat(column)
    })

    let deletedCol = this.state.extraColumns.filter( col => exCol.indexOf(col) == -1 );

    deletedCol.map((column) => {
      delete suggestions[column]
    })
    console.log('hesi',suggestions , table)

    // this.props.setExtraColumns(exCol)
    this.setState({table, suggestions, defaultName ,allowDelete,extraColumns:exCol})
    this.dataMap(suggestions)
    let dataMapping = []
    Object.keys(suggestions).forEach((column, index) => {
      dataMapping.push({column, name: defaultName[index]})
    })
    // this.props.setDataMapping(dataMapping)
    this.context.dispatch({type:'set_data_mapping',value:dataMapping})
  }

  reset = () => {
    this.dataMap(this.state.suggestions,true)
  }
  // getData = () => {
  //   let token = localStorage.getItem('token')
  //   axios.get('data_connector/data_preview/' + this.props.uid,
  //     {
  //       headers: {
  //         // 'Content-Type':'multipart/form-data',
  //         Authorization: 'Bearer ' + token
  //       }
  //     })
  //     .then(res => {
  //       let {table, suggestions} = res.data.data;
  //       this.setState({table: JSON.parse(table), suggestions})
  //       this.dataMap(suggestions)
  //       this.setDefault(suggestions)
  //     })
  //     .catch(err => {
  //       console.log(err.response)
  //     })
  // }
  dataMap = (data,reset = false) => {
    let dataMapping = []
    let column = {}
    let name = []
    {
      Object.keys(data).forEach((key) => {
        column['column'] = key
        column['name'] = data[key].column
        name.push(data[key].column)
        dataMapping.push(column)
        column = {}
      })
    }
    // if(this.context.state.orderName.length > 0){
    //   name = this.context.state.orderName
    // }
    // this.props.setDataMapping(dataMapping)
    this.context.dispatch({type:'set_data_mapping',value:dataMapping})
    console.log('bardia',this.context.state.orderName,name)
    this.setState({name})

    this.context.dispatch({type:'set_order_name',value:name})
  }
  setDefault = data => {
    let defaultName = []
    {
      Object.keys(data).map((key) => {
        defaultName.push(data[key].column)
      })
    }
    this.setState({defaultName})
    this.setMapping(defaultName)
  }
  setIndex = name => {
    console.log('testttt',name)
    this.setState({name})
    this.context.dispatch({type:'set_order_name',value:name})
    this.setMapping(name)
  }
  setMapping = name => {
    let data = this.state.suggestions;
    let dataMapping = []
    let column = {}
    {
      Object.keys(data).map((key, index) => {
        column['column'] = key
        column['name'] = name[index]
        dataMapping.push(column)
        column = {}
      })
    }
    // this.props.setDataMapping(dataMapping)
    this.context.dispatch({type:'set_data_mapping',value:dataMapping})
  }
  removeCol = name => {
    let {suggestions , table} = this.state;
    delete suggestions[name];
    this.setState({
      suggestions,
      showAddColumns: Object.keys(suggestions).length !== Object.keys(table).length
    })
  }
  render() {
    const {saved, table, suggestions , allowDelete} = this.state;
    const name = this.context.state.orderName;
    const {props} = this;
    return (
        <div className={`data-preview d-flex flex-column justify-content-between ${saved ? 'table-finish' : 'table-edit'}`}>
          <div>
            {/*<ConnectorHeader title="Upload File - Eventlog Creation">*/}
            {/*  If your file is already an eventlog just edit the columns if we’re mistaken. If you don’t have an eventlog you can create right here!*/}
            {/*</ConnectorHeader>*/}
            <div className="table table-select d-flex justify-content-center ml-0">
              {name.length > 0 &&
              <Scrollbars
                  renderTrackHorizontal={({style, ...props}) =>
                      <div {...props} style={{
                        ...style,
                        backgroundColor: '#C2C7ED',
                        width: "98%",
                        borderRadius: 4,
                        height: 1,
                        bottom: 20,
                        right: "1%"
                      }}/>
                  }
                  renderThumbHorizontal={({style, ...props}) =>
                      <div {...props} style={{
                        ...style,
                        backgroundColor: '#70789E',
                        borderRadius: 4,
                        cursor: "pointer",
                        height: 5,
                        bottom: 2
                      }}/>
                  }
                  className="scroll --table" style={{width: 954, height: 322}}>
                <div className="d-flex w-100">
                  {
                    Object.keys(suggestions).map((column, index) => (
                            <div key={index} className="column wmc flex-grow-1">
                              <header className="p-0">
                                <TableSelectBox
                                    width={'unset'}
                                    height={140}
                                    overFlow={true}
                                    saved={saved}
                                    index={index}
                                    suggestions={suggestions}
                                    table={table}
                                    removeCol={this.removeCol}
                                    allowDelete={allowDelete}
                                    setName={this.setIndex}
                                    name={name}
                                    title={column}
                                />
                              </header>
                              <main>
                                {
                                  Object.keys(table[name[index]]).map((value, i) => {
                                        return i < 5 && <p key={i}>{table[name[index]][value]}</p>
                                      }
                                  )
                                }
                              </main>
                            </div>
                        )
                    )
                  }

                </div>
              </Scrollbars>
              }
            </div>
          </div>
          <div className="d-flex mt-40 justify-content-between">
            {this.state.showAddColumns &&
            <div style={{position: "relative",top:-43}}>
              <div style={{position: "absolute", left: 0, bottom: 2}}>
                <HelpInfoBox direction={"left"} defaultDisplay={this.props.showHintBox}>
                  <div style={{fontWeight: 700, color: "#0A195C", textAlign: "left"}}>
                    This is where you can ADD new columns or Edit currents.
                  </div>
                </HelpInfoBox>
              </div>
              <div onClick={() => this.context.dispatch({type:'set_page',value:'Add Columns'})}
                   className="btn btn-outline d-flex align-items-center justify-content-around py-0">
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.2473 20.4428H21.4999" stroke="#8A0FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.28 3.79479C14.0557 2.86779 15.45 2.73186 16.3962 3.49173C16.4485 3.53296 18.1295 4.83879 18.1295 4.83879C19.169 5.46719 19.492 6.80311 18.8494 7.82259C18.8153 7.87718 9.31195 19.7645 9.31195 19.7645C8.99578 20.1589 8.51583 20.3918 8.00291 20.3973L4.36353 20.443L3.54353 16.9723C3.42866 16.4843 3.54353 15.9718 3.8597 15.5773L13.28 3.79479Z" stroke="#8A0FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M11.5208 6.00098L16.973 10.1881" stroke="#8A0FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p className="main-purple fw600 f12">Edit Columns</p>
              </div>
            </div>
            }
            <div className="btn" onClick={() => this.context.dispatch({type:'set_page',value:'Load Data'})}>Save & Continue</div>
          </div>
        </div>
    );
  }
}
